import React from 'react';
import cx from 'clsx';
import { useDeviceTypeIsMobile } from '@/hooks';
import { WrapModalProps, wrapModalPromise } from '../../modal';
import { SignLoginModal } from '../SignLoginModal';
import style from './index.module.css';

interface LoginMethodModalProps extends WrapModalProps<string> {
  hasConnected?: boolean; // 弹出登陆弹窗前是否进行了connect，用于判断用户是否走完完整登录流程
}

export const LoginMethodModal = ({
  hide,
  onResolve,
  onReject,
  hasConnected,
}: LoginMethodModalProps) => {
  const isMobile = useDeviceTypeIsMobile();
  return (
    <div className={cx(isMobile && style.mobile)}>
      <SignLoginModal
        hide={hide}
        onResolve={onResolve}
        onReject={onReject}
        hasConnected={hasConnected}
      />
    </div>
  );
};

export const selectLoginMehod = wrapModalPromise<{ hasConnected?: boolean }, string>(
  LoginMethodModal,
  {
    containerClassName: style.modalContainer,
  },
);
